// extracted by mini-css-extract-plugin
export default {"SideBar":"SideBar_SideBar__7FEK1","MainContentWrapper":"SideBar_MainContentWrapper__XyxXu","Icon":"SideBar_Icon__BuTGH","Calendar":"SideBar_Calendar__CdsHq"};